import { render } from "./_base-content.vue?vue&type=template&id=006340b6"
import script from "./_base-content.vue?vue&type=script&lang=js"
export * from "./_base-content.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./_base-content.vue?vue&type=style&index=0&id=006340b6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__